<div class="d-flex flex-row">
  <div class="p-1 w-50 mt-1">{{'PRINT.textColor' | translateHs }}:</div>
  <div class="p-1 w-100">
    <input class="form-control form-select-sm" (click)="setColorPickerVisible('fill')"
      [ngStyle]="getColorPickerStyle('fill')" [ngModelOptions]="{standalone: true}" [(ngModel)]="textStyle.textColor" />
    <color-sketch *ngIf="fillPickerVisible" (onChangeComplete)="onPick($event, 'fill')" width="320px">
    </color-sketch>
  </div>
</div>
<div class="d-flex flex-row" *ngIf="objectName === 'imprint'">
  <div class="p-1 w-50 mt-1">{{'PRINT.backgroundColor' | translateHs }}:</div>
  <div class="p-1 w-100">
    <input class="form-control form-select-sm" (click)="setColorPickerVisible('background')"
      [ngStyle]="getColorPickerStyle('background')" [ngModelOptions]="{standalone: true}"
      [(ngModel)]="textStyle.bcColor" /><!-- TODO: Remove function call from template -->
    <color-sketch *ngIf="bcPickerVisible" (onChangeComplete)="onPick($event, 'background')" width="320px">
    </color-sketch>
  </div>
</div>
<div class="d-flex flex-row">
  <div class="p-1 w-50 mt-1">{{'STYLER.textSize' | translateHs }}:</div>
  <div class="p-1 w-100">
    <select class="form-control form-select-sm form-select" [(ngModel)]="textStyle.textSize"
      [ngModelOptions]="{standalone: true}" style="flex-grow: 1;">
      <option *ngFor="let size of stylingOptions.textSizes">{{size}}
      </option>
    </select>
  </div>
</div>
<div class="d-flex flex-row">
  <div class="p-1 w-50 mt-1">{{'STYLER.font' | translateHs }}:</div>
  <div class="p-1 w-100">
    <select class="form-control form-select-sm form-select" [(ngModel)]="textStyle.fontFamily"
      [ngModelOptions]="{standalone: true}">
      <option *ngFor="let font of stylingOptions.fonts">{{font}}
      </option>
    </select>
  </div>
</div>
<div class="d-flex flex-row">
  <div class="p-1 w-50 mt-1">{{'STYLER.fontStyle' | translateHs }}:</div>
  <div class="p-1 w-100">
    <select class="form-control form-select-sm form-select" [(ngModel)]="textStyle.fontStyle"
      [ngModelOptions]="{standalone: true}">
      <option [ngValue]="fontStyle" *ngFor="let fontStyle of stylingOptions.fontStyles">
        {{getTranslation('PRINT',fontStyle)}}<!-- TODO: Remove function call from template -->
      </option>
    </select>
  </div>
</div>
<div class="d-flex flex-row" *ngIf="objectName === 'title'">
  <div class="p-1 w-50 mt-1">{{'PRINT.textDraw' | translateHs }}:</div>
  <div class="p-1 w-100">
    <select class="form-control form-select-sm form-select" [(ngModel)]="textStyle.textDraw"
      [ngModelOptions]="{standalone: true}">
      <option [ngValue]="textDraw" *ngFor="let textDraw of stylingOptions.textDrawTypes">
        {{getTranslation('COMMON',textDraw)}}<!-- TODO: Remove function call from template -->
      </option>
    </select>
  </div>
</div>
<div class="d-flex flex-row">
  <div class="p-1 w-50 mt-1">{{'PRINT.textPosition' | translateHs }} X:</div>
  <div class="p-1 w-100">
    <select class="form-control form-select-sm form-select" [(ngModel)]="textStyle.posX"
      [ngModelOptions]="{standalone: true}">
      <option [ngValue]="positionX" *ngFor="let positionX of positionOptions.positionsX">
        {{getTranslation('PRINT',positionX)}}<!-- TODO: Remove function call from template -->
      </option>
    </select>
  </div>
</div>

<div class="d-flex flex-row mb-2">
  <div class="p-1 w-50 mt-1">{{'PRINT.textPosition' | translateHs }} Y:</div>
  <div class="p-1 w-100">
    <select class="form-control form-select-sm form-select" [(ngModel)]="textStyle.posY"
      [ngModelOptions]="{standalone: true}">
      <option [ngValue]="positionY" *ngFor="let positionY of positionOptions.positionsY">
        {{getTranslation('PRINT',positionY)}}<!-- TODO: Remove function call from template -->
      </option>
    </select>
  </div>
</div>